<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>契約修正</h1>

<mat-card class="cur-card">
  <mat-card-content>
    <form [formGroup]="contModInputForm">
      <!-- 契約修正コンポーネント -->
      <app-sgkb980d-input [codeConversionMstMap]="codeConversionMstMap">
      </app-sgkb980d-input>
    </form>
  </mat-card-content>
</mat-card>